import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#EB5A0A",
      d: "M0 20C0 8.954 8.954 0 20 0s20 8.954 20 20-8.954 20-20 20S0 31.046 0 20"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M10.37 18.763c5.367-2.532 8.94-4.215 10.735-5.03 5.107-2.317 6.18-2.716 6.87-2.733.153 0 .49.033.72.233.185.167.231.383.262.55.03.167.061.516.03.783-.276 3.165-1.472 10.845-2.085 14.377-.261 1.5-.767 2-1.258 2.05-1.073.099-1.886-.767-2.914-1.5-1.625-1.15-2.53-1.866-4.11-2.999-1.825-1.3-.644-2.016.399-3.182.276-.3 4.984-4.964 5.076-5.38.015-.05.015-.25-.092-.35s-.26-.067-.383-.034c-.169.033-2.745 1.9-7.76 5.58-.736.55-1.396.817-1.994.8-.66-.016-1.917-.4-2.868-.733-1.15-.4-2.07-.616-1.994-1.316.046-.366.507-.733 1.365-1.116",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }